module.exports = __webpack_public_path__ + "static/nurse_buddy-cd3a4853c69ae1202437ad2d2cadcb1a.svg";